import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

// ─────────────────────────────────────────────────────────────────────────────
// ProtectedRoute
//
// Wrap any admin route with this to require authentication.
//
// Usage:
//   <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>} />
// ─────────────────────────────────────────────────────────────────────────────

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // While checking token on mount, show nothing (avoids flash)
  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#061a12",
        color: "#c3b996",
        fontSize: "1rem",
        letterSpacing: "0.1em",
        fontFamily: "'DM Sans', sans-serif",
      }}>
        <div style={{ textAlign: "center" }}>
          <div className="auth-spinner" style={{
            width: 40, height: 40,
            border: "3px solid rgba(195,185,150,0.2)",
            borderTopColor: "#c3b996",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
            margin: "0 auto 1rem",
          }} />
          Verifying session...
        </div>
      </div>
    );
  }

  // Not logged in → redirect to login, remembering where they came from
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Optional: require admin role
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
